import React from 'react';
import classNames from 'classnames';

import { DEFAULT_LOGO_SIZE } from '@eb/eds-global-header';
import { LogoWordmarkBrand } from '@eb/eds-iconography';
import { Icon } from '@eb/eds-icon';

const DEFAULT_LOGO_TYPE = <LogoWordmarkBrand />;
const DEFAULT_LOGO_COLOR = 'ui-orange';
const DEFAULT_LOGO_TITLE = 'Eventbrite';

const GlobalHeaderLogo = ({ info }) => {
    const {
        url,
        iconType = DEFAULT_LOGO_TYPE,
        iconColor = DEFAULT_LOGO_COLOR,
        iconTitle = DEFAULT_LOGO_TITLE,
        iconWidth = DEFAULT_LOGO_SIZE.width,
        iconHeight = DEFAULT_LOGO_SIZE.height,
        backgroundColor,
        shouldUseSpecialWidth,
        ...linkProps
    } = info;
    const className = classNames('consumer-header__logo-link', {
        [`eds-bg-color--${backgroundColor}`]: backgroundColor,
        'consumer-header--logo-special-width': !!shouldUseSpecialWidth,
    });

    return (
        <a
            href={url}
            className={className}
            data-spec="consumer-header-logo-link"
            {...linkProps}
        >
            <Icon
                type={iconType}
                color={iconColor}
                title={iconTitle}
                isBlockLevel={true}
                height={iconHeight}
                width={iconWidth}
                data-spec="consumer-header-logo"
            />
        </a>
    );
};

export default GlobalHeaderLogo;
